import { UID } from 'shared/api/query/constants';
import {
  gridPageTile as gridPageTileConfig,
  gridPageTileMedia as gridPageTileMediaConfig,
  storageObject as storageObjectConfig,
} from 'shared/api/query/configs.json';
import { storageObjectEdges } from '@/api/query/nebula/storage-object';

export const gridPageTileMediaChildren = [
  { attr: UID },
  { attr: gridPageTileMediaConfig.edges.tile, model: gridPageTileConfig.model, children: [{ attr: UID }] },
  {
    attr: gridPageTileMediaConfig.edges.image,
    model: storageObjectConfig.model,
    children: storageObjectEdges,
    default: null,
  },
  { attr: gridPageTileMediaConfig.edges.videoUrl, default: '' },
];
